import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`notifications/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getUsersNotifications(UserId, NotificationId, keyword, pageNumber, pageSize, order) {
        return Api().get(`notifications/users/adm?UserId=${UserId}&NotificationId=${NotificationId}&keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getTotaisUsersNotifications(NotificacaoId) {
        return Api().get(`notifications/users/totais/${NotificacaoId}`);
    },
    getOne(id) {
        return Api().get(`notifications/adm/${id}`);
    },
    create(data){
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        return Api().post(`notifications`, data, config);
    },
    update(data) {
        return Api().put(`notifications/${data.id}`, data);
    },
    resend_NotificationUserChannel(data) {
        return Api().post('notifications/resend_NotificationUserChannel', data);
    }
}